import { lazy } from "react";

export { prototypeMeta } from "./Page";

export default lazy(() => import("./Page"));
